import React, {useState, useEffect} from "react";
import {Trans, useTranslation} from "react-i18next";
import {useSnackbar} from "notistack";

import SectionBox from "../../elements/SectionBox/SectionBox";
import TextField from "../../elements/TextField/TextField";
import OutlinedSelect from "../../elements/OutlinedSelect/OutlinedSelect";
import Button from "../../elements/Button/Button";

import "./CampaignDetailsPage.scss";


import {callAPI} from "../../utils/utils";

const CampaignDetailsBox = (props) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [ name, setName ] = useState("");
  const [ target, setTarget ] = useState("");
  const [ targets, setTargets ] = useState([]);
  const [ loading, setLoading ] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    callAPI("campaigns/update", "POST", {hash: props.hash, name: name, target: target}).then(() => {
      enqueueSnackbar(t("CampaignDetailsBox.SaveSuccess"), {variant:'success'});
      setLoading(false);
    }).catch(() => {
      enqueueSnackbar(t("CampaignDetailsBox.SaveError"), {variant:'error'});
      setLoading(false);
    });
  }

  useEffect(() => {
    callAPI("campaigns/details", "POST", {hash: props.hash}).then((data) => {
      setName(data.campaign.display_name);
      setTarget(data.campaign.target_id);
      setTargets(data.targets);
      setLoading(false);
    });
  }, [props.hash]);

  const openTarget = () => {
    window.open(targets.find(item => item.value === target).url);
  }

  return (
    <SectionBox loading={loading} headline={"CampaignDetailsBox.Headline"} info={"CampaignDetailsBox.InfoText"} width={1000}>
      <form onSubmit={handleSubmit} style={{maxWidth:1000}}>
        <div>
          <TextField
            style={{marginRight:10,flexGrow:1}}
            id="firstName"
            label={t("CampaignDetailsBox.DisplayName")}
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
            <OutlinedSelect
              id={'country'}
              label={t("CampaignDetailsBox.Target")}
              value={target}
              width={400}
              required
              onChange={(value) => {setTarget(value);}}
              items={targets}
            />
        </div>
        <div>
          <Button size="medium" className="public__link" onClick={() => openTarget()}>
            <Trans>CampaignDetailsBox.ShowTarget</Trans>
          </Button>
          <Button
            type="submit"
            size="large"
            variant="contained"
            color="primary"
            working={loading}
            className="submit"
          >
            {t("CampaignDetailsBox.Submit")}
          </Button>
        </div>
      </form>
    </SectionBox>
  );
}

export default CampaignDetailsBox;